module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-low-learnUltra.a78e78c6f0e59a35fef49e20a1cbe45e.svg";